/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {Col} from "react-bootstrap";
import {Glyphicon} from "../../GlyphIcon";
import React from "react";

export const StreamBankAddItemButton = (props) => {
    const {
        show = true,
        onAdd = () => {},
        dataTypeName,
        className = '',
    } = props;

    if (!show) { return null; }

    return (
        <Col className={['sb-mutable-list-add-section', className].filter(Boolean).join(' ')} onClick={() => onAdd()}>
            <a>
                <Glyphicon glyph="plus-sign">Add {dataTypeName}</Glyphicon>
            </a>
        </Col>
    );
};
